import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { serchSelect, serchSelectManage } from "@/mixins/index";
import { addPamseMange, returnPamseMange, updataPamseMange } from "@/api/dataAll/pamseMange";
import { mapState } from "vuex";
export default {
  name: "addPamseMange",
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        id: "",
        game: "",
        platform: "",
        parameter: '',
        type: '',
        op_ad_channel: 'jl'
      },
      typeForms: [{
        id: "1",
        type_name: 'click'
      }, {
        id: "2",
        type_name: 'show'
      }],
      opAdChannel: [{
        label: "巨量",
        value: 'jl'
      }, {
        label: "广点通",
        value: 'gdt'
      }],
      rules: {
        game: [{
          required: true,
          message: "游戏",
          trigger: "blur"
        }],
        platform: [{
          required: true,
          message: "平台",
          trigger: "blur"
        }],
        parameter: [{
          required: true,
          message: "参数",
          trigger: "blur"
        }],
        op_ad_channel: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$returnPamseMan, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (!id) {
                  _context.next = 8;
                  break;
                }

                _context.next = 4;
                return returnPamseMange({
                  id: id
                });

              case 4:
                _yield$returnPamseMan = _context.sent;
                data = _yield$returnPamseMan.data;

                _this.gamechangeManage(data.game);

                _this.searchData = _objectSpread(_objectSpread({}, _this.searchData), data);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this2.searchData.kind = 1;
          var req = _this2.searchData.id ? updataPamseMange : addPamseMange;
          req(_this2.searchData).then(function (res) {
            if (res.status == 200) {
              Message.success('操作成功');

              if (_this2.searchData.id) {
                _this2.$emit("refreshDataList");
              }

              _this2.resetForm();
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        game: "",
        platform: "",
        parameter: '',
        type: '',
        op_ad_channel: 'jl'
      };
      this.$refs.ruleForm.resetFields();
    }
  }
};